// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2n9yf","imageUploader":"EGiftCard_imageUploader__OAGFn"};